import React, { useState, useEffect } from "react";
import ScriptLoader from "./Helpers/ScriptLoader";

// Universal pixel init code for programatic display campaign 
const UniPixel = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const scriptSrc = "https://js.adsrvr.org/up_loader.1.1.0.js";

  useEffect(() => {
    const initPixelScript = () => {
      if (window && window.ttd_dom_ready) {
        window.ttd_dom_ready(() => {
          if (typeof TTDUniversalPixelApi === "function") {
            const universalPixelApi = new TTDUniversalPixelApi();
            universalPixelApi.init(
              "a8iuvbe",
              ["zysz3jv"],
              "https://insight.adsrvr.org/track/up"
            );
          }
        });
      }
    };
    if (isLoaded) {
      initPixelScript();
    }
  }, [isLoaded]);

  return (
    <span>
      <ScriptLoader
        scriptSrc={scriptSrc}
        isLoadedCallback={() => setIsLoaded(true)}
      />
    </span>
  );
};

export default UniPixel;
